import React, { useEffect, useState } from "react";
import Layout from "../../components/Layout";
import { Button, Row, Col, Modal, Image, InputNumber } from "antd";
import { useDispatch, useSelector } from "react-redux";
import ReactTooltip from "react-tooltip";
import { COLORS } from "../../config/theme";
import { Helmet } from "react-helmet";
import { logo1 } from "../../assets/images";
import {
  getSubscribedPlan,
  getStripId,
  buySubscriptionPlanBeta,
  changeSubscriptionPlanBeta,
  cancelSubscribedPlanBeta,
  ////
  // createCheckoutSession,
  // buySubscriptionPlan,
  // changeSubscriptionPlan,
  // cancelSubscribedPlan,
} from "../../redux/actions/Membership/membership.actions";
import PlanCard from "./PlanCard";
import BetaModal from "./Components/BetaModal";

const card1 = [
  {
    cardListTitle: "Access to Wave Portal",
    cardListDetail: "Manage all your cards in one place",
  },
  {
    cardListTitle: "Share Wave Cards in many ways",
    cardListDetail: "Including tapping your card and scanning the QR code",
  },
  {
    cardListTitle:
      "View, manage, and invite all company users' cards in one portal",
    cardListDetail:
      "Ability to invite your team to collaborate and manage the portal",
  },
  {
    cardListTitle: "Access to user-friendly Analytics Dashboard",
    cardListDetail: "Track your cards performance",
  },
  {
    cardListTitle: "Mass editor for Wave Cards details",
    cardListDetail:
      "Edit many cards at once to save time and edit them separately",
  },
];
const card2 = [
  {
    cardListTitle: "Everything in Professional Plan",
    cardListDetail: "Every feature from professional plan is included",
  },
  {
    cardListTitle: "Contact Exchange feature",
    cardListDetail:
      "Receive others' business cards as well by exchanging both contacts",
  },
  {
    cardListTitle: "Contacts Inbox Page View",
    cardListDetail:
      "All coming contacts from the exchange contact feature will receive to this page which can be exported later to your CRM",
  },
  {
    cardListTitle: "Download contacts to mobile or export as CSV to CRM",
    cardListDetail:
      "Ability to download single contact or as CSV to be uploaded to your CRM",
  },
  {
    cardListTitle: "Advanced Analytics Tool",
    cardListDetail:
      "Advanced analytics tool that will show more details about the performance of your cards, also ability to track all your card's Scanning locations",
  },
  {
    cardListTitle: "Advanced Analysis Dashboard",
    cardListDetail: "To see and monitor all your cards and leads performance",
  },

  {
    cardListTitle: "Add to Apple/Android Wallet option",
    cardListDetail:
      "Add your card to Apple or Android wallet to show your card QR code",
  },
  {
    cardListTitle: "Switch between card profiles",
    cardListDetail:
      "Ability to switch between different card page layouts and details that are being saved as presets. Great for multiple businesses entrepreneurs",
  },
  {
    cardListTitle: "Switch between card page themes",
    cardListDetail:
      "Ability to switch between many pre-made themes for the card page",
  },
  {
    cardListTitle: "Advanced Calendar/Booking Management System",
    cardListDetail:
      "This will allow you to show a digital calendar on your card page and give visitors to book your services easier",
  },
  {
    cardListTitle: "Add a video to the Wave Page",
    cardListDetail: "Embed YouTube videos to the card page",
  },
];
const card3 = [
  {
    cardListTitle: "Everything in Professional Plan & Business Plan",
    cardListDetail: "Every feature from professional & Business is included",
  },
  {
    cardListTitle: "Zaiper and CRMs Integrations",
    cardListDetail: "Integration between your leads inbox and CRMs",
  },
  {
    cardListTitle: "Custom Domain",
    cardListDetail:
      "Add your own business domain to have the Cards links more custom for your brand",
  },
  {
    cardListTitle: "VIP Customer Service",
    cardListDetail: "Priority customer service support",
  },
];
const businessPrices = [
  "$7 per card",
  "$6 for up to 10 cards",
  "$4 for up to 100 cards",
];
const enterprisePrices = [
  "$8 per card",
  "$7 for up to 10 cards",
  "$5 for up to 100 cards",
];

const UpgradeToPremium = () => {
  const dispatch = useDispatch();
  // Error Modal
  const { subscribedPlan } = useSelector((state) => state.membership);
  const { user } = useSelector((state) => state.auth);
  const [selectedPlan, setSelectedPlan] = useState("");
  const [cancelModalVisible, setCancelModalVisible] = useState(false);
  const [wavecardQuantity, setWavecardQuantity] = useState(
    subscribedPlan?.wavecardQuantity?.toString() || ""
  );
  const [annualPurchase, setAnnualPurchase] = useState(false);
  const [showPurchaseModal, setShowPurchaseModal] = useState(false);
  const [betaModal, setBetaModal] = useState(false);
  const [firstLoad, setFirstLoad] = useState(false);
  const { primaryDark, primary, danger, lightGray } = COLORS;
  // const createCheckoutSessionHandler = () => {
  //   setShowPurchaseModal(false);
  //   setWavecardQuantity("");
  //   if (user.stripeId && subscribedPlan?.paymentStatus === "SUCCESS") {
  //     dispatch(changeSubscriptionPlan(wavecardQuantity));
  //   } else if (user.stripeId && subscribedPlan?.paymentStatus !== "SUCCESS") {
  //     dispatch(buySubscriptionPlan(wavecardQuantity));
  //   } else {
  //     dispatch(createCheckoutSession(wavecardQuantity));
  //   }
  // };
  const createCheckoutSessionHandler = () => {
    setShowPurchaseModal(false);
    if (
      user.stripeId &&
      subscribedPlan?.paymentStatus === "SUCCESS" &&
      subscribedPlan.selectedPlan
    ) {
      const data = { wavecardQuantity, selectedPlan };
      dispatch(changeSubscriptionPlanBeta(data));
    } else {
      const data = { wavecardQuantity, annualPurchase, selectedPlan };
      dispatch(buySubscriptionPlanBeta(data));
    }
  };
  const cancelSubscriptionModal = () => {
    setSelectedPlan("");
    setCancelModalVisible(true);
  };

  // const cancelSubscriptionHandler = () => {
  //   setCancelModalVisible(false);
  //   dispatch(cancelSubscribedPlan());
  // };
  const cancelSubscriptionHandler = () => {
    setCancelModalVisible(false);
    dispatch(cancelSubscribedPlanBeta());
  };
  const handleButtonProperty = (selectedPlan, wavecardQuantity) => {
    if (selectedPlan === "ENTERPRISE") {
      if (wavecardQuantity > 9) return primaryDark;
      else return lightGray;
    } else {
      if (wavecardQuantity > 0) return primaryDark;
      else return lightGray;
    }
  };
  const calculateFinalPricing = (wavecardQuantity) => {
    let finalPrice = 0;
    if (selectedPlan === "BUSINESS") {
      if (wavecardQuantity > 0 && wavecardQuantity < 10) {
        finalPrice = wavecardQuantity * 8;
      } else if (wavecardQuantity >= 10 && wavecardQuantity < 100) {
        finalPrice = wavecardQuantity * 6;
      } else if (wavecardQuantity >= 100) {
        finalPrice = wavecardQuantity * 5;
      }
    } else if (selectedPlan === "ENTERPRISE") {
      if (wavecardQuantity > 0 && wavecardQuantity < 10) {
      } else if (wavecardQuantity >= 10 && wavecardQuantity < 100) {
        finalPrice = wavecardQuantity * 7;
      } else if (wavecardQuantity >= 100) {
        finalPrice = wavecardQuantity * 6;
      }
    }
    if (annualPurchase) {
      return finalPrice * 12;
    } else {
      return finalPrice;
    }
  };
  useEffect(() => {
    if (!firstLoad) {
      return;
    }
    if (!subscribedPlan?.paymentStatus) {
      setBetaModal(true);
    }
  }, [firstLoad, subscribedPlan?.paymentStatus]);
  useEffect(() => {
    if (!subscribedPlan?.paymentStatus) {
      dispatch(getSubscribedPlan());
      setTimeout(() => {
        setFirstLoad(true);
      }, 2000);
    }
    if (!user?.stripeId) {
      dispatch(getStripId());
      return;
    }
  }, [dispatch, user?.stripeId, subscribedPlan?.paymentStatus]);
  useEffect(() => {
    if (subscribedPlan?.wavecardQuantity) {
      setWavecardQuantity(subscribedPlan?.wavecardQuantity?.toString());
    }
  }, [subscribedPlan]);
  return (
    <Layout heading="Subscriptions and Plans">
      <Helmet>
        <title>Subscriptions and Plans</title>
      </Helmet>
      <ReactTooltip />
      <Row
        span={24}
        style={{
          textAlign: "center",
          paddingTop: "1rem",
          paddingLeft: "1.5rem",
          paddingRight: "1.5rem",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <p
          style={{
            fontWeight: "600",
            fontSize: "1.5rem",
            textAlign: "center",
          }}
        >
          What are the benefits of upgrading your card's to the premium?
        </p>
        <Row span={20}>
          <p
            style={{
              fontSize: "1rem",
              textAlign: "center",
            }}
          >
            Upgrading your card's to the premium will change each of your cards
            to be not only a digital business card but also to be a lead
            generation tool that can capture high quality leads easily and
            generate more revenue and growth for your business!
          </p>
        </Row>
        <Row
          span={24}
          style={{
            display: "flex",

            marginTop: "1rem",
            flexDirection: "column",
          }}
        >
          <Row
            style={{
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Col style={{ margin: ".5rem" }}>
              <InputNumber
                size="large"
                name="cards"
                value={wavecardQuantity}
                onChange={(e) => setWavecardQuantity(e)}
                style={{ borderRadius: 8, width: "100%" }}
                placeholder="Cards quantity"
              />
            </Col>
            <Col style={{ margin: ".5rem" }}>
              <div
                style={{
                  width: "16rem",
                  height: "3.3rem",
                  display: "flex",
                  backgroundColor: "lightGray",
                  borderRadius: "3rem",
                  overflow: "hidden",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "50%",
                    flexDirection: "column",
                    backgroundColor: annualPurchase ? "#4666ff" : "lightGray",
                    borderRadius: "3rem",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setAnnualPurchase((prev) => !prev);
                  }}
                >
                  <p
                    style={{
                      fontWeight: "600",
                      color: annualPurchase ? "white" : "gray",
                    }}
                  >
                    Billed Yearly
                  </p>
                  <p
                    style={{
                      fontWeight: "700",
                      color: annualPurchase ? "yellow" : "gray",
                    }}
                  >
                    10% Discount
                  </p>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "50%",
                    borderRadius: "3rem",
                    backgroundColor: !annualPurchase ? "#4666ff" : "lightGray",
                    color: "gray",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setAnnualPurchase((prev) => !prev);
                  }}
                >
                  <p
                    style={{
                      fontWeight: "600",
                      color: !annualPurchase ? "white" : "gray",
                    }}
                  >
                    Billed Monthly
                  </p>
                </div>
              </div>
            </Col>
          </Row>
          <Row
            style={{
              margin: "0 .5rem",
            }}
          >
            <p style={{ color: "#4666ff", fontWeight: "600" }}>
              {"Price changes by increasing the cards quantity"}
            </p>
          </Row>
        </Row>

        <Col span={24}>
          <Row
            style={{
              display: "flex",
              marginTop: "2rem",
              paddingBottom: "4rem",
            }}
            xs={24}
            md={24}
            justify="space-between"
          >
            <PlanCard
              planType={"PROFESSIONAL"}
              paymentStatus={
                (subscribedPlan?.selectedPlan === "BUSINESS" ||
                  subscribedPlan?.selectedPlan === "ENTERPRISE") &&
                subscribedPlan.paymentStatus === "SUCCESS"
                  ? false
                  : true
              }
              features={card1}
              cancelSubscriptionModal={() => cancelSubscriptionModal()}
              setShowPurchaseModal={() => {
                setShowPurchaseModal(true);
              }}
              setSelectedPlan={setSelectedPlan}
              cardPrices={[]}
            />
            <PlanCard
              planType={"BUSINESS"}
              paymentStatus={
                subscribedPlan?.selectedPlan === "BUSINESS" &&
                subscribedPlan.paymentStatus === "SUCCESS"
                  ? true
                  : false
              }
              features={card2}
              cancelSubscriptionModal={() => cancelSubscriptionModal()}
              setShowPurchaseModal={() => {
                setShowPurchaseModal(true);
              }}
              setSelectedPlan={setSelectedPlan}
              cardPrices={businessPrices}
              annualPurchase={annualPurchase}
              wavecardQuantity={wavecardQuantity}
            />
            <PlanCard
              planType={"ENTERPRISE"}
              paymentStatus={
                subscribedPlan?.selectedPlan === "ENTERPRISE" &&
                subscribedPlan.paymentStatus === "SUCCESS"
                  ? true
                  : false
              }
              features={card3}
              cancelSubscriptionModal={() => cancelSubscriptionModal()}
              setShowPurchaseModal={() => {
                setShowPurchaseModal(true);
              }}
              setSelectedPlan={setSelectedPlan}
              cardPrices={enterprisePrices}
              annualPurchase={annualPurchase}
              wavecardQuantity={wavecardQuantity}
            />
          </Row>
        </Col>

        <Modal
          visible={cancelModalVisible}
          footer={null}
          closable={false}
          centered
          width="25rem"
          bodyStyle={{
            height: 150,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div>
            <Col>
              <Row>
                <span
                  style={{
                    fontSize: "0.9rem",
                    fontWeight: "500",
                    marginBottom: "1.3rem",
                    textAlign: "center",
                  }}
                >
                  Are you sure want to cancel subscription?
                </span>
              </Row>
              <Row
                style={{
                  width: "100%",
                  alignContent: "space-evenly",
                  justifyContent: "space-evenly",
                }}
                span={16}
              >
                <Button
                  shape="round"
                  type="primary"
                  style={{
                    background: primary,
                    borderColor: primary,
                  }}
                  onClick={() => {
                    setCancelModalVisible(false);
                  }}
                >
                  No
                </Button>
                <Button
                  shape="round"
                  type="primary"
                  style={{
                    background: primary,
                    borderColor: primary,
                  }}
                  onClick={() => {
                    cancelSubscriptionHandler();
                  }}
                >
                  Yes
                </Button>
              </Row>
            </Col>
          </div>
        </Modal>
        <Modal
          visible={showPurchaseModal}
          footer={null}
          closable={false}
          centered
          bodyStyle={{
            display: "flex",
          }}
        >
          <div
            style={{
              display: "flex",
            }}
          >
            <div
              style={{
                border: "1px solid gray",
                borderRadius: "0.5rem",
                textAlign: "center",
                paddingTop: "1rem",
                paddingLeft: "1rem",
                paddingRight: "1rem",
                paddingBottom: "1rem",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginBottom: "2rem",
                  flexDirection: "column",
                  marginRight: "1.5rem",
                  marginLeft: "1.5rem",
                }}
              >
                <Image src={logo1} preview={false} draggable={false} />
                <p
                  style={{
                    fontSize: "1.5rem",
                    color: "black",
                    fontWeight: "500",
                  }}
                >
                  {`Buy ${
                    selectedPlan.charAt(0) + selectedPlan.slice(1).toLowerCase()
                  } Plan`}
                </p>
                {annualPurchase && (
                  <p
                    style={{
                      fontSize: "1rem",
                      color: "black",
                    }}
                  >
                    {`with 10% savings`}
                  </p>
                )}
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: "2rem",
                }}
              >
                <div style={{ display: "flex", flex: 1 }}>
                  <p>Enter the number of cards</p>
                </div>
                <div style={{ display: "flex", flex: 1 }}>
                  <InputNumber
                    size="large"
                    name="cards"
                    value={wavecardQuantity}
                    onChange={(e) => setWavecardQuantity(e)}
                    style={{ borderRadius: 8, width: "100%" }}
                    placeholder="Cards quantity"
                  />
                </div>
              </div>
              <div>
                <div
                  style={{
                    display: "flex",
                    marginBottom: "2rem",
                    alignContent: "space-between",
                  }}
                >
                  <div style={{ display: "flex", flex: 1 }}>
                    <p>Total cost for cards</p>
                  </div>
                  <div style={{ display: "flex", flex: 1 }}>
                    <p>{`AU$ ${calculateFinalPricing(wavecardQuantity)}`}</p>
                  </div>
                </div>
              </div>
              <div>
                <div
                  style={{
                    display: "flex",
                    marginBottom: "2rem",
                    alignContent: "space-between",
                  }}
                >
                  <div style={{ display: "flex", flex: 1 }}>
                    <p>Total Cost</p>
                  </div>
                  <div style={{ display: "flex", flex: 1 }}>
                    <p
                      style={{
                        textDecoration:
                          wavecardQuantity > 0 ? "line-through" : "none",
                        textDecorationColor: "red",
                      }}
                    >
                      {annualPurchase === true
                        ? `AU$
                        ${(
                          calculateFinalPricing(wavecardQuantity) -
                          // +
                          // calculateFinalPricing(wavecardQuantity) * 0.1

                          calculateFinalPricing(wavecardQuantity) *
                            // + calculateFinalPricing(wavecardQuantity) * 0.1

                            0.1
                        ).toFixed(2)}`
                        : `AU$
                        ${calculateFinalPricing(wavecardQuantity)
                          // + calculateFinalPricing(wavecardQuantity) * 0.1
                          .toFixed(2)}`}
                    </p>
                    {wavecardQuantity > 0 ? (
                      <p style={{ marginLeft: ".5rem" }}>Free</p>
                    ) : null}
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  marginBottom: "2rem",
                  justifyContent: "space-evenly",
                }}
              >
                <Button
                  shape="round"
                  type="primary"
                  style={{
                    background: danger,
                    borderColor: primaryDark,
                    width: "6rem",
                  }}
                  onClick={() => {
                    setShowPurchaseModal(false);
                  }}
                >
                  Close
                </Button>
                <Button
                  shape="round"
                  type="primary"
                  disabled={
                    (selectedPlan === "ENTERPRISE" && wavecardQuantity < 10) ||
                    !wavecardQuantity
                  }
                  style={{
                    background: handleButtonProperty(
                      selectedPlan,
                      wavecardQuantity
                    ),

                    borderColor: primaryDark,
                    width: "6rem",
                  }}
                  onClick={() => {
                    createCheckoutSessionHandler();
                  }}
                >
                  Buy
                </Button>
              </div>
            </div>
          </div>
        </Modal>
        {betaModal && (
          <BetaModal betaModal={betaModal} setBetaModal={setBetaModal} />
        )}
      </Row>
    </Layout>
  );
};

export default UpgradeToPremium;
